import {FunctionComponent, SVGProps} from 'react';

import {Grid, SxProps} from '@mui/material';
import {Variant} from '@mui/material/styles/createTypography';
import {TypographyPropsVariantOverrides} from '@mui/material/Typography/Typography';
import {OverridableStringUnion} from '@mui/types';

import {ReactComponent as Smiley} from '../../assets/company_benefits/smile.svg';
import {ReactComponent as ArrowIndicator} from '../../assets/icons/arrow_indicator.svg';
import {ReactComponent as Dot} from '../../assets/icons/dot.svg';
import {ReactComponent as DownloadArrow} from '../../assets/icons/download_arrow.svg';
import {ReactComponent as EmpionCheck} from '../../assets/icons/empion_check.svg';
import {ReactComponent as Eyeball} from '../../assets/icons/eyeball.svg';
import {ReactComponent as BuildingColumns} from '../../assets/job_postings/icons/building-columns.svg';
import {ReactComponent as Building} from '../../assets/job_postings/icons/building.svg';
import {ReactComponent as Check} from '../../assets/job_postings/icons/check.svg';
import {ReactComponent as Clock} from '../../assets/job_postings/icons/clock.svg';
import {ReactComponent as Comment} from '../../assets/job_postings/icons/comment.svg';
import {ReactComponent as Knowledge} from '../../assets/job_postings/icons/knowledge.svg';
import {ReactComponent as MoneyBill} from '../../assets/job_postings/icons/money-bill.svg';
import {ReactComponent as RemoteWork} from '../../assets/job_postings/icons/remote.svg';
import {ReactComponent as Spa} from '../../assets/job_postings/icons/spa.svg';

export enum IconType {
  MoneyBill,
  BuildingColumns,
  RemoteWork,
  Clock,
  Knowledge,
  Comment,
  Building,
  Check,
  Spa,
  Smiley,
  Dot,
  ArrowIndicator,
  EmpionCheck,
  DownloadArrow,
  Eyeball,
}

const Icons: Record<IconType, FunctionComponent<SVGProps<SVGSVGElement> & {title?: string}>> = {
  [IconType.MoneyBill]: MoneyBill,
  [IconType.BuildingColumns]: BuildingColumns,
  [IconType.RemoteWork]: RemoteWork,
  [IconType.Clock]: Clock,
  [IconType.Knowledge]: Knowledge,
  [IconType.Comment]: Comment,
  [IconType.Building]: Building,
  [IconType.Check]: Check,
  [IconType.Spa]: Spa,
  [IconType.Smiley]: Smiley,
  [IconType.Dot]: Dot,
  [IconType.ArrowIndicator]: ArrowIndicator,
  [IconType.EmpionCheck]: EmpionCheck,
  [IconType.DownloadArrow]: DownloadArrow,
  [IconType.Eyeball]: Eyeball,
};

interface Props {
  iconColor: string;
  icon: IconType;
  minWidth?: string;
  variant?: OverridableStringUnion<Variant | 'inherit', TypographyPropsVariantOverrides>;
  sx?: SxProps;
  size?: string;
}

export const Icon = ({icon, iconColor, minWidth = '18px', sx, size}: Props) => {
  const IconVariant = Icons[icon];
  return (
    <Grid
      item
      sx={{
        display: 'flex',
        alignItems: 'center',
        ...sx,
      }}
    >
      <IconVariant fill={iconColor} style={{minWidth, ...(size && {width: size, height: size})}} />
    </Grid>
  );
};
